import {
  APP_NETWORK_REQUEST,
  APP_NETWORK_RESPONSE,
  APP_NETWORK_FAILURE,
  APP_NETWORK_SELECT_EXPERTS,
  APP_NETWORK_FILTER_UPDATE,
  APP_NETWORK_RESULT_STATE_UPDATE,
} from "../../../actions/types";

const defaultKeywords = ``;

const initialState = {
  defaultState: {
    keyword: "",
    size: 100,
    from: 0,
    activePage: 1,
    totalExperts: 0,
    terms: [],
    country: "",
    experts: [],
    university: [],
    selectedNodes: [],
    listType: "longList",
    totalConnections: {},

    year: "",
    activeSortItem: {
      value: "citation_count",
      label: "Total Related Citation",
    },
  },

  isFetching: false,
  isMoreResult: true,
  isMoreResultLoading: false,
  nodes: [],
  edges: {},
  keywordCloud: [],
  locationCloud: [],
  selectedNodes: [],
  error: false,
  isInitialScreen: true,
  keyword: "",
  size: 100,
  from: 0,
  activePage: 1,
  totalExperts: 0,
  terms: [],
  country: "",
  experts: [],
  university: [],
  totalConnections: {},

  year: "",
  activeSortItem: {
    value: "citation_count",
    label: "Total Related Citation",
  },
  listType: "longList",
  isAffNode: false,
  networkType: undefined,
};

const updateFilters = (state, action) => {
  let {
    terms = [],
    country = "",
    experts = [],
    university = [],
    size = 100,
    selectedNodes = [],
    year = "",
    listType = "longList",
    isAffNode = false,
    networkType,
  } = action.payload;

  terms = terms || [];
  let keyword = terms
    .map((l) => l.label)
    .join(",")
    .split(",");
  keyword = keyword.join(", ");

  return {
    ...state,
    experts,
    country,
    terms,
    university,
    selectedNodes: selectedNodes || [],
    size: size,
    year: year,
    listType,
    isAffNode: isAffNode,
    networkType,
  };
};

const updateSelectedNodes = (state, action) => {
  const { selectedNodes } = action.payload;
  return {
    ...state,
    selectedNodes: selectedNodes || [],
  };
};

const setRequest = (state, action) => {
  let {
    terms = [],
    country = "",
    experts = [],
    university = [],
    size = 100,
    selectedNodes = [],
    year = "",
    listType = "longList",
    isAffNode = false,
  } = action.payload;

  terms = terms || [];
  let keyword = terms
    .map((l) => l.label)
    .join(",")
    .split(",");
  keyword = keyword.join(", ");


  return {
    ...state,
    isFetching: true,
    error: false,
    isInitialScreen: false,
    nodes: [],
    edges: {},
    keywordCloud: [],
    locationCloud: [],
    experts,
    country,
    terms,
    university,
    selectedNodes: selectedNodes || [],
    size: size,
    keyword: keyword ? keyword : defaultKeywords,
    year: year,
    listType,
    isAffNode: isAffNode || false,
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    isInitialScreen: false,
    node_output: [],
    edges_output: [],
    keyword: "",
    totalExperts: 0,
    activeSortItem: {
      value: "citation_count",
      label: "Total Related Citation",
    },
    terms: [],
    country: "",
    year: "",
    experts: [],
    university: [],
    selectedNodes: [],
    size: 100,
    listType: "longList",
    isAffNode: false,
  };
};

const setResponse = (state, action) => {
  let { totalExperts = "-", activePage, activeSortItem } = action.payload;

  let nodes = action.payload.node_output || [];
  let edges = action.payload.edges_output || {};
  let keywordCloud = action.payload.keyword_cloud || [];
  let locationCloud = action.payload.location_cloud || [];
  let totalConnections = action.payload.total_connections || {};
  return {
    ...state,
    isFetching: false,
    error: false,
    nodes: nodes,
    edges: edges,
    keywordCloud: keywordCloud,
    locationCloud: locationCloud,
    isInitialScreen: false,
    totalExperts,
    activePage,
    activeSortItem,
    totalConnections,
  };
};

const updateResultStates = (state, action) => {
  let payload = action.payload || {};
  let nodes = state.nodes || [];
  nodes = nodes.map((l) => {
    if (payload.expertId === l.id) {
      let shortListed = l.shortListed;
      if (payload.rmv) {
        shortListed = false;
      } else {
        shortListed = true;
      }

      return {
        ...l,
        shortListed: shortListed,
      };
    }

    return {
      ...l,
    };
  });
  return {
    ...state,
    nodes: nodes || [],
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_NETWORK_REQUEST:
      return setRequest(state, action);

    case APP_NETWORK_RESPONSE:
      return setResponse(state, action);

    case APP_NETWORK_FAILURE:
      return setFailure(state, action);

    case APP_NETWORK_SELECT_EXPERTS:
      return updateSelectedNodes(state, action);

    case APP_NETWORK_FILTER_UPDATE:
      return updateFilters(state, action);

    case APP_NETWORK_RESULT_STATE_UPDATE:
      return updateResultStates(state, action);

    default:
      return state;
  }
};
